// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","logo__icon":"Logo_logo__icon__Boznl"};